// https://expertacademy.arlo.co/api/2012-02-01/pub/resources/eventtemplatesearch?fields=Categories,Name,ViewUri,TemplateID,Media

import { getValidCategoryIDString } from "./lib";

export default async function getEventTemplates(activeFilter = null) {
    try {
        let queryUrl = `/api/arlo/fetch?data_type=eventtemplatesearch?fields=Categories,Name,ViewUri,TemplateID,Media,Description&filter=categoryid=${getValidCategoryIDString()}`;
        if (activeFilter && activeFilter?.CategoryID)
            queryUrl = `/api/arlo/fetch?data_type=eventtemplatesearch?fields=Categories,Name,ViewUri,TemplateID,Media,Description&filter=categoryid=${activeFilter.CategoryID}`;

        let response = await fetch(queryUrl, {
            method: 'GET',
        });

        if (!response.ok) {
            console.error(`HTTP error! status: ${response.status}`);
            return { success: false, error: `An error occurred. Status: ${response.status}` };
        } else {
            const data = await response.json();

            return { success: true, data };
        }
    } catch (error) {
        console.error('Fetch error:', error);
        return { success: false, error: error.message };
    }
}